import {
    Alert,
    Avatar,
    Button,
    Checkbox,
    FilledInput,
    FormControl,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Paper,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material"

import { styled } from '@mui/system';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import styles from './person.module.css';
import { useEffect, useState } from "react";
import MaterialSelect from "../../components/MaterialSelect/component";
import { AVATAR_TYPES, TIPO_DOCUMENTOS } from "../../utilities/constants";
import { Box } from "@mui/system";
import { validateDoc, validateDocExt, validateEmail, validatePassword } from "../../utilities/general";
import { useDispatch } from "react-redux";
import { createPerson, limpiarPerson } from "./reducers/actions";
import { usePersonSelector } from "./reducers/store";
import { selectError, selectLoading, selectPersona } from "./reducers/reducer";
import Loading from "../../components/Loading/component";
import MaterialFileUpload from "../../components/MaterialFileUpload/component";
import MaterialConfirmUser from "../../components/MaterialConfirmUser/component";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import { makeStyles } from '@mui/styles';

function PersonComponent(props) {
    const headerStyle = { margin: 0 }
    const avatarStyle = { backgroundColor: '#1bbd7e', marginBottom: 10 }


    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState('');

    const [tipoDoc, setTipoDoc] = useState('Seleccione un tipo de documento');
    const [emptyTipoDoc, setEmptyTipoDoc] = useState(false);
    const [numDoc, setNumDoc] = useState('');
    const [emptyNumDoc, setEmptyNumDoc] = useState(false);
    const [nombres, setNombres] = useState('');
    const [emptyNombre, setEmptyNombre] = useState(false);
    const [nombresPopUp, setNombresPopUp] = useState('');
    const [apellidos, setApellidos] = useState('');
    const [emptyApellidos, setEmptyApellidos] = useState(false);
    const [correo, setCorreo] = useState('');
    const [correoPopUp, setCorreoPopUp] = useState('');
    const [correoInvalido, setCorreoInvalido] = useState(false);
    const [confPassword, setconfPassword] = useState('');
    const [invalidPass, setInvalidPass] = useState(false);
    const [condiciones, setCondiciones] = useState(false);
    const [emptyMail, setEmptyMail] = useState(false);
    const [emptyCondiciones, setEmptyCondiciones] = useState(false);
    const [severity, setSeverity] = useState('info');
    const [message, setMessage] = useState(false);
    const [messageNumDoc, setMessageNumDoc] = useState(false);
    const [messageTipoDoc, setMessageTipoDoc] = useState(false);
    const [messageNombre, setMessageNombre] = useState(false);
    const [messageApellido, setMessageApellido] = useState(false);
    const [messageMail, setMessageMail] = useState(false);
    const [messagePassword, setMessagePassword] = useState(false);
    const [messageCondiciones, setMessageCondiciones] = useState(false);
    const [imageFile, setImageFile] = useState(false);
    const [open, setOpen] = useState(false);
    const [emailValidate, setEmailValidate] = useState(false);
    const [emptyMailValidate, setEmptyMailValidate] = useState(false);



    const handleClose = () => {
        dispatch(limpiarPerson());
        setOpen(false);
    };

    const useStyles = makeStyles({
        errorInput: {
            '& input': {
                borderBottomColor: 'red',
            },
        },
    });

    const dispatch = useDispatch();
    const loading = usePersonSelector(selectLoading);
    const persona = usePersonSelector(selectPersona);
    const error = usePersonSelector(selectError);

    const onAvatarHandler = (file) => {
        setImageFile(file)
        // console.log("imageFile person", imageFile)
    }


    const handleTogglePasswordVisibility = () => {
        //console.log("ASDASDASDASDASDASDSADa")
        setShowPassword(!showPassword);
        //console.log(showPassword)
    };

    const onLimpiarFormularioHandler = () => {
        setTipoDoc('Seleccione un tipo de documento')
        setNumDoc('')
        setNombres('')
        setApellidos('')
        setCorreo('')
        setPassword('')
        setconfPassword('')
        setCondiciones(false)
        setMessage(false)
        setImageFile(false)
    }

    const onTipoDocHandler = (event) => {
        setTipoDoc(event.target.value)
        console.log("tipodoc", event.target.value)
        if (event.target.value === 'Seleccione un tipo de documento') {
            setSeverity('error');
            setMessageTipoDoc('Seleccione el tipo de documento');
            setEmptyTipoDoc(true)
        } else {
            setEmptyTipoDoc(false)
            setEmptyNumDoc(false)
        }
    }


    const onNumDocHandler = (event) => {
        setNumDoc(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessageNumDoc('El número de documento es obligatorio');
            setEmptyNumDoc(true)
        } else {
            setMessageNumDoc(false)
            setEmptyNumDoc(false)
        }
    }

    const onNombresHandler = (event) => {
        setNombres(event.target.value)
        setNombresPopUp(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessageNombre('Ingresa tu nombre completo');
            setEmptyNombre(true)
        } else {
            setMessageNombre(false)
            setEmptyNombre(false)
        }
    }

    const onApellidosHandler = (event) => {
        setApellidos(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessageApellido('Por favor escribe aquí tus apellidos.');
            setEmptyApellidos(true)
        } else {
            setMessageApellido(false)
            setEmptyApellidos(false)
        }
    }

    const onCorreoHandler = (event) => {
        setCorreo(event.target.value)
        setCorreoPopUp(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessageMail('Ingresa tu correo electrónico, por favor.');
            setEmptyMail(true)
        } else {
            setMessageMail(false)
            setEmptyMail(false)
        }
    }

    const onPasswordHandler = (event) => {
        setPassword(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessagePassword('La contraseña es obligatoria.');
            setInvalidPass(true)
        } else {
            setMessagePassword(false)
            setInvalidPass(false)
        }
    }
    const onConfPasswordHandler = (event) => {
        setconfPassword(event.target.value)
        if (event.target.value === '') {
            setSeverity('error');
            setMessagePassword('por favor confirme su contraseña.');
            setInvalidPass(true)
        } else {
            setMessagePassword(false)
            setInvalidPass(false)
        }
    }

    const onCondicionesHandler = (event) => {
        setCondiciones(event.target.checked)
        if (event.target.checked === false) {
            setSeverity('error');
            setMessageCondiciones('Acepte terminos y condiciones de uso.');
            setEmptyCondiciones(true)
        } else {
            setMessageCondiciones(false)
            setEmptyCondiciones(false)
        }
    }

    const onFormHandler = (event) => {
        event.preventDefault();
        const usuario = {
            tipoDoc, numDoc, nombres, apellidos, correo, password
        }
        setEmptyTipoDoc(false);
        setEmptyNumDoc(false);
        setEmptyNombre(false);
        setEmptyApellidos(false);
        setEmptyMail(false);
        setEmptyMailValidate(false);
        setMessage(false);
        setMessageNumDoc(false);
        setMessageApellido(false);
        setMessageNombre(false);
        setMessageMail(false);
        setInvalidPass(false);
        setCorreoInvalido(false);
        setEmptyCondiciones(false);
        setMessageCondiciones(false);
        setEmailValidate(false);


        if (tipoDoc === 'Seleccione un tipo de documento' || !numDoc || !nombres || !apellidos || !correo || !password || !confPassword || !condiciones) {
            setMessage('Por favor diligencia todos los campos. ')

            if (!numDoc) {
                setSeverity('error');
                setMessageNumDoc('El número de documento es obligatorio.');
                setEmptyNumDoc(true)
            }


            if (tipoDoc === 'CC' && numDoc) {
                if (!validateDoc(numDoc)) {
                    setSeverity('error');
                    setMessageNumDoc('El número de cédula no puede contener letras.');
                    setEmptyNumDoc(true)
                }
            }

            if (tipoDoc === 'PP' && numDoc) {
                if (!validateDocExt(numDoc)) {
                    setSeverity('error');
                    setMessageNumDoc('El pasaporte debe contener números y letras.');
                    setEmptyNumDoc(true)
                }
            }
            if (tipoDoc === 'DNI' && numDoc) {
                if (!validateDocExt(numDoc)) {
                    setSeverity('error');
                    setMessageNumDoc('El DNI debe contener números y letras.');
                    setEmptyNumDoc(true)
                }
            }

            if (tipoDoc === 'TE' && numDoc) {
                if (!validateDoc(numDoc)) {
                    setSeverity('error');
                    setMessageNumDoc('La Tarjeta de extranjeria no puede contener letras.');
                    setEmptyNumDoc(true)
                }
            }
            if (tipoDoc === 'CE' && numDoc) {
                if (!validateDoc(numDoc)) {
                    setSeverity('error');
                    setMessageNumDoc('La Cédula de extranjeria no puede contener letras.');
                    setEmptyNumDoc(true)
                }
            }


            if (!nombres) {
                setSeverity('error');
                setMessageNombre('Ingresa tu nombre completo.');
                setEmptyNombre(true)
            }
            if (!apellidos) {
                setSeverity('error');
                setMessageApellido('Por favor escribe aquí tus apellidos.');
                setEmptyApellidos(true)
            }
            if (!correo) {
                setSeverity('error');
                setMessageMail('Ingresa tu correo electrónico, por favor.');
                setEmptyMail(true)
            }

            if (!password && !confPassword) {
                setSeverity('error');
                setMessagePassword('La contraseña es obligatoria.');
                setInvalidPass(true)
            }
            if (password && !confPassword) {
                setSeverity('error');
                setMessagePassword('Por favor confirme su contraseña.');
                setInvalidPass(true)
            }
            if (!password && confPassword) {
                setSeverity('error');
                setMessagePassword('La contraseña es obligatoria.');
                setInvalidPass(true)
            }

            if (password && confPassword && password !== confPassword) {
                setSeverity('error');
                setMessagePassword('Las contraseñas no coinciden.');
                setInvalidPass(true)
            }

            if (condiciones === false) {
                setSeverity('error');
                setMessageCondiciones('Acepte terminos y condiciones de uso.');
            }

            if (tipoDoc === 'Seleccione un tipo de documento') {
                setSeverity('error');
                setEmptyTipoDoc(true)
                setMessageTipoDoc('Selecciona un tipo de documento.');
            }
            return
        }

        let isValidate = true;
        if (!validatePassword(password)) {
            setSeverity('error');
            setMessagePassword('Ingrese una contraseña valida.');
            setInvalidPass(true)
            isValidate = false
        }

        //       console.log("AASDASD11")

        if (password !== confPassword) {
            setSeverity('error');
            setMessagePassword('Las contraseñas deben ser iguales.');
            setInvalidPass(true)
            isValidate = false

        }
        //       console.log("AASDASD10")

        if (!validateEmail(correo)) {
            setSeverity('error');
            setEmailValidate('Ingrese un correo valido.');
            setEmptyMailValidate(true)
            isValidate = false
        }
        //       console.log("AASDASD9")

        if (tipoDoc === 'CC' && numDoc) {
            if (!validateDoc(numDoc)) {
                setSeverity('error');
                setMessageNumDoc('El número de cédula no puede contener letras.');
                setEmptyNumDoc(true)
                isValidate = false
            }

        }

        //       console.log("AASDASD7")
        if (tipoDoc === 'PP' && numDoc) {
            if (!validateDocExt(numDoc)) {
                setSeverity('error');
                setMessageNumDoc('El pasaporte debe contener números y letras.');
                setEmptyNumDoc(true)
                isValidate = false
            }
        }

        //console.log("AASDASD6")
        if (tipoDoc === 'DNI' && numDoc) {
            if (!validateDocExt(numDoc)) {
                setSeverity('error');
                setMessageNumDoc('El DNI debe contener números y letras.');
                setEmptyNumDoc(true)
                isValidate = false
            }
        }

        //console.log("AASDASD5")
        if (tipoDoc === 'TE' && numDoc) {
            if (!validateDoc(numDoc)) {
                setSeverity('error');
                setMessageNumDoc('La Tarjeta de extranjeria no puede contener letras.');
                setEmptyNumDoc(true)
                isValidate = false
            }
        }

        //console.log("AASDASD4")
        if (tipoDoc === 'CE' && numDoc) {
            if (!validateDoc(numDoc)) {
                setSeverity('error');
                setMessageNumDoc('La Cédula de extranjeria no puede contener letras.');
                setEmptyNumDoc(true)
                isValidate = false
            }
        }

        console.log("AASDASD3")

        // if (numDoc.length > 100) {
        //     setSeverity('error');
        //     setMessageNumDoc('El número de documento debe tener menos de 100 caracteres.');
        //     setEmptyNumDoc(true)
        //     isValidate = false
        // }

        // if (nombres.length > 100) {
        //     setSeverity('error');
        //     setMessageNombre('Los nombres no pueden contener más de 100 carácteres.');
        //     setEmptyNombre(true)
        //     isValidate = false
        // }
        // if (apellidos.length > 100) {
        //     setSeverity('error');
        //     setMessageApellido('Los apellidos no pueden contener más de 100 carácteres.');
        //     setEmptyApellidos(true)
        //     isValidate = false
        // }

        console.log("AASDASD2", isValidate)
        if (!isValidate) {
            return
        }

        console.log("AASDASD1")
        dispatch(createPerson({ usuario, imageFile }));
        return

    }


    useEffect(() => {
        //Persona creada exitosamente
        if (persona) {
            onLimpiarFormularioHandler();
            setOpen(true);
        }
    }, [persona, open, dispatch]);
    return (
        <div className={`${styles.contenedor}`}>
            
        <Grid className={`${styles.grid}`}>
            <Loading show={loading} text={'Apreciado usuario, estamos validando la información ingresada por favor espere un momento...'} />
            <Paper elevation={10} className={`${styles.paper}`} >
                <MaterialConfirmUser

                    title={`¡Felicitaciones, ${nombresPopUp}!`}
                    cuerpo={`Tu cuenta está casi lista. Falta un último paso y es el mas fácil, ingresa al correo ${correoPopUp} y confirma tu cuenta.`}
                    open={open}
                    cuenta={persona.cuenta}
                    onClose={handleClose}
                    persona={persona.cuenta}
                />
                {message && <Alert severity={severity}>{message}</Alert>}
                {persona && <Alert severity={'info'}>
                    {persona.message}
                </Alert>
                }
                {error && <Alert severity={'error'}>{error.message}</Alert>}
                <form onSubmit={onFormHandler}>
                    <Grid align='center'>
                        <Avatar style={avatarStyle}>
                            <AddCircleOutlineIcon />
                        </Avatar>
                        <h2 style={headerStyle}>Persona</h2>
                        <Typography variant='caption' gutterBottom>¡Completa el formulario para crear tu cuenta!</Typography>
                    </Grid>
                    <div className={`${styles.campos}`} >
                        * Campos obligatorios.
                    </div>


                    <Box m={1}>
                        <MaterialSelect
                            //className={`${emptyTipoDoc ? styles.error : ''}`}
                            onChangeEvent={onTipoDocHandler}
                            selectValue={tipoDoc}
                            items={TIPO_DOCUMENTOS}
                            placeholder=''
                            //error={emptyTipoDoc}
                            estilo={emptyTipoDoc}
                        />

                        <p className={`${styles.errorText}`} >
                            {emptyTipoDoc ? messageTipoDoc : ''}
                        </p>
                    </Box>

                    <Box m={1}>
                        <Tooltip title="Ingrese el número de documento 
                                sin puntos, especios ni guiones" placement="top">

                            <TextField
                                //className={`${emptyNumDoc ? styles.error : ''}`}
                                label='Número documento *'
                                value={numDoc}
                                fullWidth
                                onChange={onNumDocHandler}
                                spacing={5}
                                error={emptyNumDoc} />
                        </Tooltip>
                        <p className={`${styles.errorText}`} >
                            {emptyNumDoc ? messageNumDoc : ''}
                        </p>
                    </Box>

                    <Box m={1}>
                        <TextField
                            //className={`${emptyNombre ? styles.error : ''}`}
                            label='Nombre *'
                            value={nombres}
                            fullWidth
                            onChange={onNombresHandler}
                            spacing={5}
                            error={emptyNombre} />

                        <p className={`${styles.errorText}`} >
                            {emptyNombre ? messageNombre : ''}
                        </p>
                    </Box>

                    <Box m={1}>
                        <TextField
                            //sx={{borderColor: emptyApellidos ? 'red' : 'inherit'}}
                            label='Apellidos'
                            value={apellidos}
                            fullWidth
                            onChange={onApellidosHandler}
                            error={emptyApellidos}
                        // InputProps={{
                        //     classes: {
                        //       root: emptyApellidos ? classes.errorInput : '',
                        //     },
                        //   }}

                        />

                        <p className={`${styles.errorText}`} >
                            {emptyApellidos ? messageApellido : ''}
                        </p>
                    </Box>
                    <Box m={1}>
                        <TextField
                            //className={`${emptyMailValidate ? styles.error : ''} || ${emptyMail ? styles.error : ''}`}
                            fullWidth
                            placeholder=""
                            onChange={onCorreoHandler}
                            value={correo}
                            label='Correo *'
                            error={emptyMailValidate || emptyMail}
                        />
                        <p className={`${styles.errorText}`} >
                            {emptyMail ? messageMail : ''}
                        </p>

                        <p className={`${styles.errorText}`} >
                            {emptyMailValidate ? emailValidate : ''}
                        </p>
                    </Box>
                    <Box m={1}>

                        <Tooltip title={
                            <div>
                                <p>Debes incluir en la contraseña</p>
                                <ul>
                                    <li>8 caracteres mínimo.</li>
                                    <li>15 caracteres máximo.</li>
                                    <li>1 mayúscula.</li>
                                    <li>1 minúscula.</li>
                                    <li>1 número.</li>
                                    <li>1 carácter especial.</li>
                                </ul>
                            </div>
                        } placement="top">

                            <TextField
                                //className={`${invalidPass ? styles.error : ''}`}
                                id="standard-Password-input"
                                error={invalidPass}
                                onChange={onPasswordHandler}
                                type={showPassword ? 'text' : 'password'}
                                fullWidth
                                value={password}
                                label="Contraseña *"
                                autoComplete="current-password"
                                //type="password"
                                placeholder="Contraseña"
                                InputProps={{
                                    endAdornment: (
                                        <span className=" ">
                                            <IconButton onClick={handleTogglePasswordVisibility} end="edge">
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>

                                        </span>
                                    ),
                                }}

                            />
                        </Tooltip>


                    </Box>
                    <Box m={1}>
                        <TextField
                            //className={`${invalidPass ? styles.error : ''}`}
                            error={invalidPass}
                            //id="standard-confPassword-input"
                            type={showPassword ? 'text' : 'password'}
                            onChange={onConfPasswordHandler}
                            fullWidth
                            value={confPassword}
                            label="Confirme su contraseña *"
                            //autoComplete="current-password"
                            placeholder="Confirme su contraseña"
                            InputProps={{
                                endAdornment: (
                                    <span className=" ">
                                        <IconButton onClick={handleTogglePasswordVisibility} end="edge">
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>

                                    </span>
                                ),
                            }}

                        />
                        <p className={`${styles.errorText}`} >
                            {invalidPass ? messagePassword : ''}
                        </p>
                    </Box>

                    <Grid style={{ margin: "10px 0" }}>
                        <MaterialFileUpload
                            label={'Seleccione un archivo...'}
                            uploadLabel={'Subir'}
                            onUpload={imageFile ? onAvatarHandler : onAvatarHandler}
                            value={imageFile}
                            types={AVATAR_TYPES}
                            placeholder={'Adjunta la imagen de tu logo aquí'}
                            fileName={imageFile?.name}
                        />
                    </Grid>

                    <p className={`${styles.labelFont}`}>
                        {<Checkbox onChange={onCondicionesHandler}
                            checked={condiciones}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        * He leído y acepto<a href=" " target="_blank"> los términos y condiciones de uso de Avanti-It.</a>

                    </p>
                    {messageCondiciones && <Alert severity={severity}>{messageCondiciones}</Alert>}

                    {/*error && <Alert severity={'error'}>{error.messageCondiciones}</Alert>*/}
                    <Box m={1}>

                        <Button className={`${styles.submitButton}`}
                            color='primary'
                            size='large'
                            type='submit'
                            variant='contained'
                        >
                            Crear cuenta
                        </Button>
                    </Box>

                </form>
            </Paper>


        </Grid>
        </div>
    );
}
export default PersonComponent;